import {LitElement, html, nothing} from 'lit';
import stylesheet from './toggle-details.scss?as=stylesheet';
import {BreakpointMixin} from './breakpoint-mixin';
import {classMap} from 'lit/directives/class-map.js';
import {MutationObserverMixin} from 'extensions/ui-mixins';

// eslint-disable-next-line new-cap
export class ToggleDetails extends BreakpointMixin(MutationObserverMixin(LitElement)) {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			_limit: {
				state: true,
				type: Number
			},
			buttonAlign: {
				attribute: 'button-align',
				type: String
			},
			closedLabel: {
				attribute: 'closed-label',
				type: String
			},
			label: {
				type: String
			},
			limit: {
				type: String
			},
			open: {
				type: Boolean
			},
			selector: {
				type: String
			}
		};
	}

	mutationObserverOptions = {
		attribute: false,
		childList: true,
		subtree: false
	};

	constructor () {
		super();

		this.buttonAlign = 'left';
		this.closedLabel = '';
		this.label = '';
		this.limit = '5';
		this.open = false;
		this.selector = '';

		this._breakpoints = window?.getComputedStyle(document.querySelector('html'), ':after')?.getPropertyValue('content').split('|') || [];
	}

	handleBreakpoint (index) {
		const limitSplit = this.limit.split(',');

		this._limit = parseInt(limitSplit[Math.min(limitSplit.length - 1, index)] || limitSplit, 10);
	}

	get toggleableChildren () {
		return this.querySelectorAll(this.selector || ':scope > *');
	}

	setHiddenState () {
		for (let i = 0; i < this.toggleableChildren.length; i++) {
			const child = this.toggleableChildren[i];
			child.hidden = !this.open && i >= this._limit;
		}
	}

	toggleOpen () {
		this.open = !this.open;

		if (this.open) {
			window.requestAnimationFrame(() => {
				this.renderRoot?.querySelector('#content')?.scrollIntoView({
					behavior: 'smooth'
				});
			});
		}
	}

	handleMutation () {
		this.setHiddenState();
	}

	updated (changedProperties) {
		if (changedProperties.has('limit') || changedProperties.has('_limit') || changedProperties.has('open')) {
			this.setHiddenState();
		}
	}

	render () {
		return html`
			<div class="content" id="content">
				<slot></slot>
			</div>

			${this.renderButton()}
		`;
	}

	renderButton () {
		if (this._limit >= this.toggleableChildren?.length) {
			return nothing;
		}

		const classes = {
			'toggle-button-wrapper': true
		};

		classes[`toggle-button-wrapper--${this.buttonAlign}`] = true;

		return html`
			<div class="${classMap(classes)}">
				<button class="toggle-button" @click="${this.toggleOpen}">
					<span class="label">${this.open && this.closedLabel ? this.closedLabel : this.label}</span>
					<span class="u-icon-chevron-down" ?hidden="${this.open}"></span>
					<span class="u-icon-chevron-up" ?hidden="${!this.open}"></span>
				</button>
			</div>
		`;
	}
};

window.customElements.define('x-toggle-details', ToggleDetails);
